// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"ea84ee9e","990":"567a0b93"}[chunkId] + ".chunk.js";
};